import { render } from "./Articles.vue?vue&type=template&id=44539d22&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=44539d22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44539d22"

export default script